import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import crudStoreModule from '@/views/apps/my-pages/crudStoreModule';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    'app-ecommerce': ecommerceStoreModule,
    'app-mypages': crudStoreModule,
  },
  strict: process.env.DEV,
})
